import BaseModel from '../../../../plugins/servicelayer/serviceTypes/baseModel';

export interface RequestSummaryItemResourceDTO {
  label?: null | string;
  displayValue?: null | string;
}

export class RequestSummaryItemResourceViewModel extends BaseModel<RequestSummaryItemResourceDTO> {
  /**
  */
  get label() { return this.dto.label; }
  set label(value) { this.dto.label = value; }
  /**
  */
  get displayValue() { return this.dto.displayValue; }
  set displayValue(value) { this.dto.displayValue = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    this.dto.label = queries.label;
    this.dto.displayValue = queries.displayValue;
  }
}

export interface RequestSummarySectionResourceDTO {
  title?: null | string;
  items?: null | RequestSummaryItemResourceDTO[];
}

export class RequestSummarySectionResourceViewModel extends BaseModel<RequestSummarySectionResourceDTO> {
  get title() { return this.dto.title; }
  set title(value) { this.dto.title = value; }

  get items() { return this.getArrayModels(() => this.dto.items, RequestSummaryItemResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    this.dto.title = queries.title;
  }
}

export interface RequestSummaryResourceDTO {
  sections?: null | RequestSummarySectionResourceDTO[];
}

export default class RequestSummaryResourceViewModel extends BaseModel<RequestSummaryResourceDTO> {
  get sections() { return this.getArrayModels(() => this.dto.sections, RequestSummarySectionResourceViewModel)!; }
  set sections(value) { this.setArrayModels(() => this.dto.sections, value); }
}
